<header>
  <div class="logo">
    <a href="/">
      <img
        class="mini-logo-img"
        src="assets/images/mini-logo.png"
        height="50px"
        width="85px"
        alt="Logo"
      />
    </a>

    <span class="section-heading tagline">Think Supply, Think ZippMat<sup>&#9415;</sup></span>
  </div>
</header>
